'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.directive('otppDatePicker', function() {
  return {
    restrict: 'AC',
    require: 'ngModel',
    link: function(scope, element, attrs, ngModel) {
      // Enforce date format and length limit
      var formatDate = function(value) {
        var formattedText;
        if (value && value.length > 4 && value.length <= 6) {
          formattedText = value.substr(0, 4) + '-' + value.substr(4);
        } else if (value && value.length >= 7) {
          formattedText = value.substr(0, 4) + '-' + value.substr(4, 2) + '-' + value.substr(6);
        } else {
          formattedText = value;
        }

        return formattedText;
      };

      var unformatDate = function(value) {
        return value.replace(/[^\d]/g, '');
      };

      ngModel.$parsers.push(function(value) {
        var val = unformatDate(value).substr(0, 8);
        var formatted = formatDate(val);
        var validDate = false;

        var splitDate = formatted.split('-');
        //Corrects month, as it starts at 0 and goes to 11 in Date object
        var enteredDate = new Date(+splitDate[0], splitDate[1] - 1, +splitDate[2]);

        if (Object.prototype.toString.call(enteredDate) === '[object Date]' && val.length === 8 &&
          !isNaN(enteredDate.getTime()) && enteredDate.getDate() ===
          parseInt(splitDate[2], 10) &&
          enteredDate.getMonth() === parseInt(splitDate[1] - 1, 10)) {
          validDate = true;
        }

        ngModel.$setValidity('validDate', validDate);
        ngModel.$viewValue = formatted;
        ngModel.$render();
        return formatted;
      });

    }
  };
});
